import GenericModel from '../generic-model';
import Product from './product';
import ProjectContact from '../company/projectContact';

export default class ProductPhoneNumber extends GenericModel {
  product?: Product;

  projectContact?: ProjectContact;

  phoneNumbers?: string;

  constructor(
    product?: Product,
    projectContact?: ProjectContact,
    phoneNumbers?: string
  ) {
    super();
    this.product = product;
    this.projectContact = projectContact;
    this.phoneNumbers = phoneNumbers;
  }
}
